<ng-container *ngIf="!!get">
    <tt-input ttLabel="stockbatch_keyno" [(ttModel)]="get.stockbatch_keyno" ttReadonly>
        <ng-container buttons>
            <tt-form-field-button ttId="materialitems_edit" ttIcon="fas fa-pen" ttTooltip="materialitems_edit" [ttTranslateTooltip]="true" (ttClick)="openMaterialItemModal()"></tt-form-field-button>
        </ng-container>
    </tt-input>
    <tt-input ttLabel="suppliers_batchno" [(ttModel)]="get.suppliers_batchno" ttReadonly></tt-input>
    <!-- <tt-input ttLabel="charge_keyno" [(ttModel)]="get.charge_keyno" ttReadonly></tt-input> -->
    <tt-input ttLabel="charge_id" [(ttModel)]="get.charge_id" ttReadonly>
        <ng-container buttons>
            <tt-form-field-button
                *ngIf="'' + get.charge_keyno > '0'"
                ttId="edit_charge"
                ttIcon="fas fa-pen"
                ttTooltip="open_charge"
                [ttTranslateTooltip]="true"
                (ttClick)="openChargeModal()"
            ></tt-form-field-button>
        </ng-container>
    </tt-input>
    <tt-input ttLabel="prod_id" [(ttModel)]="get.prod_id" ttReadonly></tt-input>
    <tt-input ttLabel="prod_name" [(ttModel)]="get.prod_name" ttReadonly></tt-input>
    <!-- <tt-input-number ttLabel="density_kg_pr_dm3" [(ttModel)]="get.density_kg_pr_dm3" ttFormatNumber ttDecimals="2" ttTextAlign="right" ttReadonly></tt-input-number> -->
    <tt-input ttLabel="order_internal_no" [(ttModel)]="get.order_internal_no" ttReadonly></tt-input>
    <tt-input ttLabel="orderline_keyno" [(ttModel)]="get.orderline_keyno" ttReadonly></tt-input>
    <!-- <tt-input ttLabel="stock_keyno" [(ttModel)]="get.stock_keyno" ttReadonly></tt-input> -->
    <div class="tt-material-item-pick__calc-form" [style.--tt-material-item-pick__calc-form-columns]="'' + get.nbr_of_items > '1' ? 3 : 2">
        <span class="tt-input__label"></span>
        <span class="tt-input__label" ttTranslateWord="w_materialitempick_beforepick" style="text-align: right"></span>
        <span *ngIf="'' + get.nbr_of_items > '1'" class="tt-input__label" ttTranslateWord="w_materialitempick_rest_full" style="text-align: right"></span>
        <span class="tt-input__label" ttTranslateWord="w_materialitempick_rest_part" style="text-align: right"></span>
        <span class="tt-input__label" ttTranslateWord="nbr_of_items"></span>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.nbr_of_items" (ttModelChange)="onChange('nbr_of_items')" ttTextAlign="right" ttReadonly ttTabable="false"></tt-input-number>
        <tt-input-number
            *ngIf="'' + get.nbr_of_items > '1'"
            ttLabelView="none"
            [(ttModel)]="get.nbr_of_items_rest_full"
            (ttModelChange)="onChange('nbr_of_items_rest_full')"
            ttTextAlign="right"
        ></tt-input-number>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.nbr_of_items_rest_part" (ttModelChange)="onChange('nbr_of_items_rest_part')" ttTextAlign="right"></tt-input-number>
        <span class="tt-input__label" ttTranslateWord="height_mm"></span>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.height_mm" (ttModelChange)="onChange('height_mm')" ttDecimals="2" ttTextAlign="right" ttReadonly ttTabable="false"></tt-input-number>
        <tt-input-number
            *ngIf="'' + get.nbr_of_items > '1'"
            ttLabelView="none"
            [(ttModel)]="get.height_mm_rest_full"
            (ttModelChange)="onChange('height_mm_rest_full')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.height_mm_rest_part" (ttModelChange)="onChange('height_mm_rest_part')" ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <span class="tt-input__label" ttTranslateWord="width_mm"></span>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.width_mm" (ttModelChange)="onChange('width_mm')" ttDecimals="2" ttTextAlign="right" ttReadonly ttTabable="false"></tt-input-number>
        <tt-input-number
            *ngIf="'' + get.nbr_of_items > '1'"
            ttLabelView="none"
            [(ttModel)]="get.width_mm_rest_full"
            (ttModelChange)="onChange('width_mm_rest_full')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.width_mm_rest_part" (ttModelChange)="onChange('width_mm_rest_part')" ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <span class="tt-input__label" ttTranslateWord="length_mm"></span>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.length_mm" (ttModelChange)="onChange('length_mm')" ttDecimals="2" ttTextAlign="right" ttReadonly ttTabable="false"></tt-input-number>
        <tt-input-number
            *ngIf="'' + get.nbr_of_items > '1'"
            ttLabelView="none"
            [(ttModel)]="get.length_mm_rest_full"
            (ttModelChange)="onChange('length_mm_rest_full')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.length_mm_rest_part" (ttModelChange)="onChange('length_mm_rest_part')" ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <span class="tt-input__label" ttTranslateWord="outer_diameter_mm"></span>
        <tt-input-number
            ttLabelView="none"
            [(ttModel)]="get.outer_diameter_mm"
            (ttModelChange)="onChange('outer_diameter_mm')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <tt-input-number
            *ngIf="'' + get.nbr_of_items > '1'"
            ttLabelView="none"
            [(ttModel)]="get.outer_diameter_mm_rest_full"
            (ttModelChange)="onChange('outer_diameter_mm_rest_full')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <tt-input-number
            ttLabelView="none"
            [(ttModel)]="get.outer_diameter_mm_rest_part"
            (ttModelChange)="onChange('outer_diameter_mm_rest_part')"
            ttDecimals="2"
            ttTextAlign="right"
        ></tt-input-number>
        <span class="tt-input__label" ttTranslateWord="thickness_mm"></span>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.thickness_mm" (ttModelChange)="onChange('thickness_mm')" ttDecimals="2" ttTextAlign="right" ttReadonly ttTabable="false"></tt-input-number>
        <tt-input-number
            *ngIf="'' + get.nbr_of_items > '1'"
            ttLabelView="none"
            [(ttModel)]="get.thickness_mm_rest_full"
            (ttModelChange)="onChange('thickness_mm_rest_full')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.thickness_mm_rest_part" (ttModelChange)="onChange('thickness_mm_rest_part')" ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <span style="grid-column: 1 / -1; margin: 0.5rem 0 1.2rem 0; padding: 0" class="col-xs-12"></span>
        <span class="tt-input__label" ttTranslateWord="volume_dm3"></span>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.volume_dm3" (ttModelChange)="onChange('volume_dm3')" ttDecimals="2" ttTextAlign="right" ttReadonly ttTabable="false"></tt-input-number>
        <tt-input-number
            *ngIf="'' + get.nbr_of_items > '1'"
            ttLabelView="none"
            [(ttModel)]="get.volume_dm3_rest_full"
            (ttModelChange)="onChange('volume_dm3_rest_full')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <tt-input-number
            ttLabelView="none"
            [(ttModel)]="get.volume_dm3_rest_part"
            (ttModelChange)="onChange('volume_dm3_rest_part')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <span class="tt-input__label" ttTranslateWord="weight_kg"></span>
        <tt-input-number ttLabelView="none" [(ttModel)]="get.weight_kg" (ttModelChange)="onChange('weight_kg')" ttDecimals="2" ttTextAlign="right" ttReadonly ttTabable="false"></tt-input-number>
        <tt-input-number
            *ngIf="'' + get.nbr_of_items > '1'"
            ttLabelView="none"
            [(ttModel)]="get.weight_kg_rest_full"
            (ttModelChange)="onChange('weight_kg_rest_full')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <tt-input-number
            ttLabelView="none"
            [(ttModel)]="get.weight_kg_rest_part"
            (ttModelChange)="onChange('weight_kg_rest_part')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
        ></tt-input-number>
        <span class="tt-input__label" ttTranslateWord="consumption_kg_total"></span>
        <span></span>
        <span *ngIf="'' + get.nbr_of_items > '1'"></span>
        <tt-input-number
            ttLabelView="none"
            [(ttModel)]="get.consumption_kg_total"
            (ttModelChange)="onChange('consumption_kg_total')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
            [ttInvalid]="!!get.consumption_kg_total && +get.consumption_kg_total < 0"
        ></tt-input-number>
        <span class="tt-input__label" ttTranslateWord="consumption_items_totalt"></span>
        <span></span>
        <span *ngIf="'' + get.nbr_of_items > '1'"></span>
        <tt-input-number
            ttLabelView="none"
            [(ttModel)]="get.consumption_items_total"
            (ttModelChange)="onChange('consumption_items_total')"
            ttDecimals="2"
            ttTextAlign="right"
            ttReadonly
            ttTabable="false"
            [ttInvalid]="!!get.consumption_items_total && +get.consumption_items_total < 0"
        ></tt-input-number>
    </div>

    <tt-button-save class="col-xs-12 col-md-3 sp-0" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
</ng-container>
<!-- params: {{ params | json }} <br />
get: {{ get | json }} -->
